<template>
  <div
    class="table-cell table-cell-tag"
    :class="{
      [name]: name,
      'cursor-pointer': canClickTag,
      'no-value': hasResultsClasses && formattedValue === '-',
      [result]: hasResultsClasses && formattedValue !== '-'
    }"
    @click="canClickTag ? onCellClick('tags', name) : null"
  >
    <i
      v-if="name === 'harassment' && formattedValue === true"
      class="bi bi-exclamation-triangle-fill text-danger harassment-info"
      data-bs-toggle="tooltip"
      :data-bs-placement="'top'"
      :title="description"
    ></i>
    <div v-else-if="isEnps">
      <NpsTooltip
        v-if="npsData && Object.keys(npsData).includes('score')"
        :npsData="npsData"
      />
      <span class="enps-value">{{ formattedValue }}</span>
    </div>
    <span
      v-else-if="name === 'participation'"
      data-bs-toggle="tooltip"
      :data-bs-placement="'top'"
      :title="description"
    >
      {{ formattedValue }}
    </span>
    <div
      v-else
      class="w-100 d-flex justify-content-center"
      data-bs-toggle="tooltip"
      :data-bs-placement="'top'"
      :title="!value ? $t('groupsComparison.noResults') : null"
    >
      <span>
        {{ formattedValue }}
      </span>
    </div>
  </div>
</template>

<script>
import NpsTooltip from '../tooltips/NpsTooltip.vue'

export default {
  name: 'PulsTableTagCell',
  components: {
    NpsTooltip
  },
  props: {
    group: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    result: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: null
    },
    onCellClick: {
      type: Function,
      default: () => {}
    },
    npsData: {
      type: Object,
      default: () => {}
    },
    zeroToHundred: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canClickTag() {
      return (
        this.name !== 'harassment' &&
        this.name !== 'participation' &&
        this.formattedValue !== '-' &&
        this.value !== null
        // !!this.value
      )
    },
    hasResultsClasses() {
      return !(this.name === 'harassment' || this.name === 'participation')
    },
    isEnps() {
      return this.name === 'enps'
    },
    formattedValue() {
      let fractionalDigits = this.isEnps || this.zeroToHundred ? 0 : 1
      switch (this.name) {
        case 'harassment':
          return !!this.value ? true : ''
        case 'participation':
          return this.value
        default:
          return this.$localeNumber(this.value, fractionalDigits)
      }
    }
  }
}
</script>

<style lang="scss">
.table-cell {
  &:hover {
    .enps-tooltip {
      display: block;
    }
  }
}
</style>
